/**
 * Visual Staging constants and enums
 */

/** Enum representing the generation types for Visual Staging */
export enum GenerationType {
  DECLUTTER_ROOM = 'declutter_room',
  EMPTY_ROOM = 'empty_room',
  FURNISHED_ROOM = 'furnished_room',
  PAINT_WALLS = 'paint_walls',
  CHANGE_FLOOR = 'change_floor',
}

/** Enum representing the processing modes for Visual Staging */
export enum ProcessingMode {
  ENTIRE_IMAGE = 'entire_image',
  PRESERVE_ZONE = 'preserve_zone',
  REPLACE_ZONE = 'replace_zone',
}

/** Enum representing the room types for Visual Staging */
export enum RoomType {
  DINING_ROOM = 'dining_room',
  LIVING_ROOM = 'living_room',
  BEDROOM = 'bedroom',
  KID_BEDROOM = 'kid_bedroom',
  TOILET = 'toilet',
  BATHROOM = 'bathroom',
  KITCHEN = 'kitchen',
  OFFICE = 'office',
  TERRACE = 'terrace',
}

/** Enum representing the style types for Visual Staging */
export enum StyleType {
  CONTEMPORARY = 'contemporary',
  IKEA = 'ikea',
  INDUSTRIAL = 'industrial',
  LUXURY = 'luxury',
  MODERN = 'modern',
  SCANDINAVIAN = 'scandinavian',
  // Kid-specific styles
  CHILD_ROOM = 'child_room',
  BOY_ROOM = 'boy_room',
  GIRL_ROOM = 'girl_room',
}

/** Enum representing the generation progress status */
export enum GenerationProgressStatus {
  PENDING = 'pending',
  IN_PROGRESS = 'in_progress',
  COMPLETED = 'completed',
  FAILED = 'failed',
}

/** Enum representing the PhotoStudio flow types */
export enum PhotoStudioFlowType {
  VISUAL_EDITING_MAGIC_ERASER = 'visual_editing_magic_eraser',
  VISUAL_EDITING_PINTURA = 'visual_editing_pintura',
  VISUAL_STAGING_ENTIRE_IMAGE = 'visual_staging_entire_image',
  VISUAL_STAGING_PRESERVE_ZONE = 'visual_staging_preserve_zone',
  VISUAL_STAGING_REPLACE_ZONE = 'visual_staging_replace_zone',
}

/** Enum representing the mask drawing types */
export enum MaskDrawingType {
  MAGIC_ERASER = 'magic_eraser',
  VIRTUAL_STAGING = 'virtual_staging',
}
